export default __webpack_public_path__ + "static/media/garmin-watch.d174ef1b.jpg";